import { selectOptionConvert } from '../../helpers/selectOptionConvert';
import { GoalBase } from '../Base/Goal';

export const TKAGoal = selectOptionConvert(GoalBase);
